import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormRadioListComplexBaseComponent } from '../base-complex/form-radio-list-complex-base.component';
import { GetDisabledMsgPipe } from '../../../../pipes/disabled-message.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgClass, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'sh-form-radio-list-base',
    templateUrl: '../base-complex/form-radio-list-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormRadioListBaseComponent)],
    standalone: true,
    imports: [NgIf, NgClass, NgFor, ReactiveFormsModule, AsyncPipe, GetDisabledMsgPipe]
})
export class ShFormRadioListBaseComponent extends ShFormRadioListComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(formValues: FormValue<string>[]): void {
        if (formValues.find(fv => fv.state === FormValueState.INDETERMINATE)) {
            console.error('ShFormRadioListBaseComponent:: indeterminate should not occur');
        }
        const filtered: string[] = formValues.filter(fv => fv.state === FormValueState.SET).map(fv => fv.value);

        if (filtered.length === 0) {
            return super.propagateChange(null as any);
        } else if (filtered.length > 1) {
            console.error('ShFormRadioListBaseComponent:: should only have one value SET, returning first one');
        }
        return super.propagateChange(filtered[0] as any);
    }

    writeValue(obj: any): void {
        super.writeValue([FormValue.wrap(obj)]);
    }
}
